<mat-toolbar class="d-flex navbar flex-row align-items-center" color="primary">
  <!--
  <a routerLink="/" routerLinkActive="active-link" class="mr-2" mat-button
      >Home</a
  >
  -->
  <div class="mr-2">
    <a routerLink="">
      <img src="assets/images/logo.png" width="64px" height="64px"
      /></a>
  </div>
  <ng-container *ngIf="(user && user.role != 'ROLE_APOTHEKE') || isTest">
    <button mat-button [matMenuTriggerFor]="listenverwaltungMenu" *ngIf="!isTest">
      Angebotsverwaltung
    </button>
    <mat-menu #listenverwaltungMenu="matMenu">
      <a
        routerLink="listen-einlesen"
        routerLinkActive="active-link"
        mat-menu-item>
        Angebote einlesen
      </a>
      <a
        routerLink="listen-zuweisen"
        routerLinkActive="active-link"
        mat-menu-item>
        Angebote zuweisen
      </a>
      <a
        routerLink="angebotsversionslisten"
        routerLinkActive="active-link"
        mat-menu-item>
        Verwaltung
      </a>
      <a
        routerLink="displays"
        routerLinkActive="active-link"
        mat-menu-item>
        Displays verwalten
      </a>
      <a
        routerLink="artikelstamm-einlesen"
        routerLinkActive="active-link"
        mat-menu-item>
        Artikelstammdaten einlesen
      </a>
    </mat-menu>
    <div class="mr-2">
      <a
        *ngIf="!isTest"
        routerLink="kundenverwaltung"
        routerLinkActive="active-link"
        mat-button>
        Kundendaten
      </a>
    </div>
    <div class="mr-2">
      <a routerLink="reporting" routerLinkActive="active-link" mat-button *ngIf="!isTest">
        Reporting
      </a>
    </div>
    <div class="mr-2">
      <a routerLink="vorgabewerte" routerLinkActive="active-link" mat-button *ngIf="!isTest">
        Vorgabewerte
      </a>
    </div>
    <div class="mr-2" *ngIf="user.role === 'ROLE_ADMIN'">
      <button mat-button [matMenuTriggerFor]="performanceMenu">
        Performance
      </button>
      <mat-menu #performanceMenu="matMenu">
        <a
          routerLink="vergleichsrechnung"
          routerLinkActive="active-link"
          mat-menu-item>
          Vergleichsrechnung
        </a>
        <a
          routerLink="activitychart"
          routerLinkActive="active-link"
          mat-menu-item>
          Aktivitätsdiagramm
        </a>
        <a
          routerLink="orderchart"
          routerLinkActive="active-link"
          mat-menu-item>
          Bestelldiagramm
        </a>
      </mat-menu>
    </div>
    <div class="mr-2" *ngIf="user.role === 'ROLE_ADMIN'">
      <a routerLink="industriepartner" routerLinkActive="active-link" mat-button>
        Mein DigiBest
      </a>
    </div>
    <div class="mr-auto" *ngIf="user.role === 'ROLE_INDUSTRIEPARTNER'">
      <a [routerLink]="'industriepartner/' + user.anbieterNummer" routerLinkActive="active-link" mat-button>
        Mein DigiBest
      </a>
    </div>
    <div class="mr-auto" *ngIf="user.role === 'ROLE_ADMIN'">
      <a routerLink="mailjet/" routerLinkActive="active-link" mat-button>
        Mailjet
      </a>
      <a href="http://www.digibest.eu:8181" target="_blank" routerLinkActive="active-link" mat-button>
        CRM
      </a>
    </div>
    <div class="mr-2" *ngIf="user && user.role === 'ROLE_ADMIN' || isTest">
      <a routerLink="showcase" routerLinkActive="active-link" mat-button>
        Demo
      </a>
    </div>
    <div class="mr-2" *ngIf="user && user.role === 'ROLE_ADMIN'">
      <mat-form-field appearance="fill">
        <input matInput [(ngModel)]="anbieterNr" autocomplete="off"/>
      </mat-form-field>
      <button matButton type="button" (click)="setAnbieterNr()">
        Ok
      </button>
    </div>
  </ng-container>
  <div *ngIf="user">
    <app-logged-in></app-logged-in>
  </div>
</mat-toolbar>
